export default __webpack_public_path__ + "static/SRUS RT220 - Product Specifications & Technical Data-dfc9987af421dd2ca27facb09d71a075.pdf";